module.exports = __webpack_public_path__ + "img/gears-solid.2ad3c17c.svg";